"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SzTabContent = exports.SzTab = void 0;

var react_1 = __importDefault(require("react"));

var react_responsive_tabs_1 = __importDefault(require("react-responsive-tabs"));

require("./SzTab.scss"); // IMPORTANT you need to include the default styles


require("react-responsive-tabs/styles.css");

exports.SzTab = function (_a) {
  var id = _a.id,
      className = _a.className,
      activeKey = _a.activeKey,
      selectTabHandle = _a.selectTabHandle,
      children = _a.children;

  function getTabs() {
    return react_1.default.Children.map(children, function (element) {
      var _a = element.props,
          title = _a.title,
          eventKey = _a.eventKey;
      return {
        title: title,
        getContent: function getContent() {
          return element;
        },
        key: eventKey,
        tabClassName: className,
        panelClassName: element.props.className
      };
    });
  }

  return react_1.default.createElement(react_responsive_tabs_1.default, {
    key: activeKey,
    uid: id,
    items: getTabs(),
    selectedTabKey: activeKey,
    onChange: function onChange(tab) {
      if (selectTabHandle) {
        selectTabHandle(tab);
      }
    }
  });
};

exports.SzTabContent = function (_a) {
  var children = _a.children;
  return react_1.default.createElement("div", null, children);
};

exports.SzTab.SzTabContent = exports.SzTabContent;
exports.default = exports.SzTab;